(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AlbumInfoExtend', AlbumInfoExtend);

    AlbumInfoExtend.$inject = ['$resource'];

    function AlbumInfoExtend($resource) {


        var findAlbumImages = function (albumId) {
            if (albumId)
                var resourceUrl = 'api/image-data-by-albumid/' + albumId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var findAlbumImagesByType = function (albumId, sizeType) {
            if (albumId)
                var resourceUrl = 'api/image-data-by-album-id-and-size-type/' + albumId + '/' + sizeType;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        return {
            findAlbumImages: findAlbumImages,
            findAlbumImagesByType: findAlbumImagesByType
        };
    }
})();
